import { render, staticRenderFns } from "./MainTop.vue?vue&type=template&id=b3cc74a8&scoped=true&"
import script from "./MainTop.vue?vue&type=script&lang=js&"
export * from "./MainTop.vue?vue&type=script&lang=js&"
import style0 from "./MainTop.vue?vue&type=style&index=0&id=b3cc74a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cc74a8",
  null
  
)

export default component.exports